module.exports = __webpack_public_path__ + "static/media/music.c8e47eb4.svg";